import React from 'react';

import {LOCALE} from "features/ui/enums";
import {SearchResult} from "features/search/types";
import {User} from "features/authentication/models/User";
import {renderInhabitDate} from "features/services/utils/date-helpers";
import {getParkingStatusName} from "features/services/utils/name-helpers";
import {DisposalForm, ObjectStatus, ParkingStatus, ResidenceType} from "features/search/filters/enums";
import {getCurrentLocale, getLocalizedKvm, getLocalizedPrice} from 'features/services/utils/env-helper';

import {Icon} from "@atoms/Media/Icon";
import { FormattedMessage } from 'react-intl';
import { Tags, TagDesign } from '@atoms/Tags/Tags';

export const renderStatusAccessor = (value: string) => (
    <Tags 
        tagDesign={TagDesign.DOT} 
        status={value as ObjectStatus} 
        className='status' 
    />
);

export const renderAsCurrency = (value: string | number | undefined, data: SearchResult) => {
    if (data.objectStatus === ObjectStatus.SOLD || data.objectStatus === ObjectStatus.BOOKED || value === undefined) return null;
    return getLocalizedPrice(value);
};

export const renderFloorAccessor = (value: string | number | undefined, data: SearchResult) => {
    if(!data.maxFloor) return value;

    return `${value} / ${data.maxFloor}`;
};

export const renderPrimaryArea = (value: string | number | undefined, data: SearchResult) => {
    if(getCurrentLocale() === LOCALE.NO && data.jmnoBraInternal) return getLocalizedKvm(data.jmnoBraInternal);
    if(!data.primaryArea) return ``;
    return getLocalizedKvm(data.primaryArea);
};

export const renderSecondaryArea = (value: string, data: SearchResult) => {
    if(!data.secondaryArea) return ``;

    return getLocalizedKvm(data.secondaryArea);
};

export const renderPurchase = (user: User | null | undefined) => (id: string) => {
    if(!user) return;

    if(user.purchases && user.purchases.length > 0) {
        const ids = user.purchases.map(purchase => purchase.objectId);

        if(ids.indexOf(id) !== -1) {
            return (
                <Icon name="check"/>
            );
        }
    }

    return;
};

export const roomRenderer = (value: string, data: SearchResult) => {
    if(data.possibleRooms) {
        return `${value}-${data.possibleRooms}`;
    }
    return value;
};

export const renderInhabitDateFunc = (value: string, data: SearchResult) => {
    return renderInhabitDate(value, data.inhabitDateEnd, data.inhabitDateDetermined);
};

export const renderParkingLot = (value: string, data: SearchResult) => {
    if(data.objectStatus === ObjectStatus.SOLD || data.objectStatus === ObjectStatus.BOOKED) return null;
    return getParkingStatusName((value as ParkingStatus));
};

export const renderCoOwning = (value: string | boolean |undefined, data: SearchResult) => {
    if(data.possibleCoOwning) {
        // if(data.objectStatus === ObjectStatus.SOLD || (data.objectStatus === ObjectStatus.BOOKED && getCurrentLocale() === LOCALE.NO)) return 'Ja';

        // let price = (data.price / 2);
        // return getLocalizedPrice(price);
        return <FormattedMessage id='jm.components.Pricelist.coOwningYes' />;
    }
    return <FormattedMessage id='jm.components.Pricelist.coOwningNo' />;
};

export const renderTotalPrice = (value: number, data: SearchResult) => {
    if(!value || typeof value === 'undefined' || data.objectStatus === ObjectStatus.SOLD || (data.objectStatus === ObjectStatus.BOOKED && getCurrentLocale() === LOCALE.NO)) return null;

    let price = value;

    if(data.otherExpenses) {
        price += data.otherExpenses;
    }

    if(data.jmnoFellesgjeld && data.residenceType === ResidenceType.APARTMENT && (data.disposalForm === DisposalForm.OWNERSHIP || data.disposalForm === DisposalForm.OWNERSHIP_APARTMENT)) {
        price += data.jmnoFellesgjeld;
    }

    return getLocalizedPrice(price);
};

export const renderTotalPriceJmoy = (value: string | number | undefined, data: SearchResult) => {
    if(!value || typeof value === 'undefined' || data.objectStatus === ObjectStatus.SOLD || (data.objectStatus === ObjectStatus.BOOKED)) return null;
    return getLocalizedPrice(value);
};

export const addDevCounter = (counter:number) => {
    return process.env.NODE_ENV === 'development' ? counter : '';
};
